// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__xgPLq","footer":"ModalFilter_footer__2zGI4"};